<div class="button-bar">
	<div class="button-container">
		<span *ngIf="cancelHidden" class="spacer"></span>
		<button type="button" mat-stroked-button color="primary" (click)="onCancel()" [disabled]="cancelDisabled"
			*ngIf="!cancelHidden">Cancel</button>
		<ng-content></ng-content>
		<ng-container *ngIf="saveMenuButtons?.length === 0; else showSaveMenu">
			<button type="submit" mat-raised-button color="primary" (click)="onSubmit()" [disabled]="saveDisabled"
				*ngIf="!saveHidden">{{saveText}}</button>
		</ng-container>
		<ng-template #showSaveMenu>
			<button type="button" [disabled]="saveDisabled" mat-raised-button color="primary" [matMenuTriggerFor]="saveMenu" *ngIf="!saveHidden">
				{{saveText }}
				<mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<mat-menu #saveMenu="matMenu" xPosition="before" yPosition="above" overlapTrigger="false">
				<button mat-menu-item *ngFor="let button of saveMenuButtons" (click)="button.action()">
					{{ button.text }}
				</button>
			</mat-menu>
		</ng-template>
	</div>
</div>